import { Link } from "react-router-dom";
import useSEO from "@/lib/useSEO";

export default function NotFound() {
  useSEO("Page Not Found | Fleece The Regime", "This page does not exist.", true);
  return (
    <main className="pt-32 px-6 min-h-screen" data-testid="not-found-page">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-primary mb-3">404</p>
      <h1 className="font-display uppercase text-4xl sm:text-5xl">This page got deported.</h1>
      <p className="mt-4 font-mono text-sm text-black/60 max-w-md leading-relaxed">
        Nothing lives at this address — no product, no page, no secret menu. The catalog is over there.
      </p>
      <Link to="/shop" data-testid="not-found-shop-link" className="mt-6 inline-block border-2 border-black bg-primary px-6 py-3 font-mono text-xs font-bold uppercase tracking-widest text-white shadow-hard btn-press">
        Shop the catalog
      </Link>
    </main>
  );
}
